module.exports = __webpack_public_path__ + "media/wyposazenie/stan@2x-3e4ee06f.png";